import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=38ba0a71&scoped=true"
import script from "./Faqs.vue?vue&type=script&lang=ts"
export * from "./Faqs.vue?vue&type=script&lang=ts"
import style0 from "./Faqs.vue?vue&type=style&index=0&id=38ba0a71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ba0a71",
  null
  
)

export default component.exports